import type { ComponentProps } from "react"

export default function EnergyRatingD(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M23.3456 9.36055L23.3455 9.36043L13.3446 0.509095C12.9773 0.181611 12.4973 -2.25237e-05 11.9992 2.09495e-09C11.5011 2.25279e-05 11.0211 0.1817 10.6538 0.509216L0.654541 9.36043C0.448577 9.54309 0.283993 9.76554 0.171293 10.0136C0.0585935 10.2616 0.000254481 10.5298 0 10.8011V22.0529C0.000606423 22.5691 0.211515 23.064 0.586456 23.4291C0.961398 23.7941 1.46975 23.9994 2 24H22C22.5302 23.9994 23.0386 23.7941 23.4135 23.4291C23.7885 23.064 23.9994 22.5691 24 22.0529V10.8011C23.9997 10.5299 23.9414 10.2617 23.8287 10.0137C23.7161 9.76566 23.5515 9.54321 23.3456 9.36055Z"
        fill={fill}
      />
      <path
        className="rating"
        d="M11.294 20H7.35086V8.36365H11.3736C12.5289 8.36365 13.5213 8.5966 14.3509 9.06251C15.1842 9.52463 15.8243 10.1894 16.2713 11.0568C16.7183 11.9243 16.9418 12.9621 16.9418 14.1705C16.9418 15.3826 16.7164 16.4243 16.2656 17.2955C15.8187 18.1667 15.1728 18.8352 14.3281 19.3011C13.4872 19.7671 12.4759 20 11.294 20ZM9.45882 18.1761H11.1918C12.0024 18.1761 12.6785 18.0284 13.2202 17.733C13.7618 17.4337 14.169 16.9886 14.4418 16.3977C14.7145 15.803 14.8509 15.0606 14.8509 14.1705C14.8509 13.2803 14.7145 12.5417 14.4418 11.9546C14.169 11.3636 13.7656 10.9224 13.2315 10.6307C12.7012 10.3352 12.0421 10.1875 11.2543 10.1875H9.45882V18.1761Z"
        fill="white"
      />
    </svg>
  )
}
